import styled, { css } from 'styled-components';

// ── Modal Shell ──────────────────────────────────────────────────────────────

export const ModalContent = styled.div`
  background: #fafafa;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem 3.2rem;
  background: #fff;
  border-bottom: 1px solid #e9eaed;
  flex-shrink: 0;
`;

export const ModalTitle = styled.span`
  font-family: Roboto-m;
  font-size: 2rem;
  color: #373333;
`;

export const CloseButton = styled.img`
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.15s;
  &:hover {
    opacity: 1;
  }
`;

export const ModalBody = styled.div`
  padding: 2.4rem 3.2rem;
  overflow-y: auto;
  flex: 1;
`;

// ── Segmented Control (All / Favorites) ─────────────────────────────────────

export const SegmentedRow = styled.div`
  display: inline-flex;
  background: #e8e8e8;
  border-radius: 24px;
  padding: 3px;
  margin-bottom: 2rem;
`;

export const SegmentOption = styled.button`
  padding: 0.6rem 2rem;
  border-radius: 20px;
  border: none;
  font-family: Roboto-m;
  font-size: 1.3rem;
  cursor: pointer;
  transition: all 0.2s;
  background: ${({ active }) => (active ? '#00FF91' : 'transparent')};
  color: ${({ active }) => (active ? '#001212' : '#6b6b6b')};
  &:hover {
    color: #001212;
  }
`;

// ── Search ──────────────────────────────────────────────────────────────────

export const SearchInput = styled.input`
  width: 100%;
  padding: 1rem 1.6rem;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-family: Roboto-r;
  font-size: 1.4rem;
  color: #373333;
  background: #fff;
  margin-bottom: 2rem;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
  &:focus {
    border-color: #00FF91;
  }
  &::placeholder {
    color: #aaa;
  }
`;

// ── Exercise Card (list view) ───────────────────────────────────────────────

export const ExerciseCard = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  padding: 1.6rem 2rem;
  margin-bottom: 1.2rem;
  cursor: pointer;
  transition: all 0.15s;
  &:hover {
    border-color: #00FF91;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;

export const CardTopLeft = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const CardExerciseName = styled.span`
  font-family: Roboto-m;
  font-size: 1.6rem;
  color: #373333;
  margin-bottom: 0.2rem;
`;

export const CardSubtitle = styled.span`
  font-family: Roboto-r;
  font-size: 1.2rem;
  color: #888;
`;

export const FavoriteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2.2rem;
  line-height: 1;
  padding: 0.4rem;
  color: ${({ active }) => (active ? '#00FF91' : '#d0d0d0')};
  transition: color 0.15s, transform 0.15s;
  flex-shrink: 0;
  &:hover {
    color: #00FF91;
    transform: scale(1.15);
  }
`;

// ── Stat Badges ─────────────────────────────────────────────────────────────

export const BadgeRow = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export const BadgeLabel = styled.span`
  font-family: Roboto-r;
  font-size: 1.1rem;
  color: #888;
`;

export const Badge = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 0.8rem 0.6rem;
`;

export const BadgeValue = styled.span`
  font-family: Roboto-m;
  font-size: 1.5rem;
  color: #373333;
  margin-bottom: 0.2rem;
`;

// ── Section Divider / Label ─────────────────────────────────────────────────

export const SectionLabel = styled.div`
  font-family: Roboto-m;
  font-size: 1.2rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
`;

// ── History Entry Card (detail view) ────────────────────────────────────────

export const EntryCard = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  padding: 1.6rem 2rem;
  margin-bottom: 1.2rem;
`;

export const EntryTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.2rem;
`;

export const EntryDate = styled.span`
  font-family: Roboto-m;
  font-size: 1.4rem;
  color: #373333;
`;

export const EntryWorkout = styled.span`
  font-family: Roboto-r;
  font-size: 1.2rem;
  color: #888;
`;

export const EntryActions = styled.div`
  display: flex;
  gap: 0.6rem;
`;

export const ActionButton = styled.button`
  background: none;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  cursor: pointer;
  padding: 0.5rem 1.2rem;
  font-family: Roboto-m;
  font-size: 1.2rem;
  transition: all 0.15s;

  ${({ danger }) =>
    danger
      ? css`
          color: #e53935;
          &:hover {
            background: #fce4ec;
            border-color: #e53935;
          }
        `
      : css`
          color: #4a4a4a;
          &:hover {
            background: #f5f5f5;
            border-color: #bbb;
          }
        `}
`;

// ── Back / Detail Header ────────────────────────────────────────────────────

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-family: Roboto-m;
  font-size: 1.4rem;
  color: #00875a;
  padding: 0;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  &:hover {
    text-decoration: underline;
  }
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1.2rem;
  margin-bottom: 2rem;
`;

export const ExerciseName = styled.h3`
  font-family: Roboto-m;
  font-size: 2rem;
  color: #373333;
  margin: 0;
`;

export const BlockTypeLabel = styled.span`
  font-family: Roboto-r;
  font-size: 1.3rem;
  color: #888;
  background: #f0f0f0;
  padding: 0.3rem 1rem;
  border-radius: 12px;
`;

// ── States ──────────────────────────────────────────────────────────────────

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  color: #969494;
  font-family: Roboto-r;
  font-size: 1.6rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6rem;
  font-family: Roboto-r;
  font-size: 1.4rem;
  color: #969494;
`;

// ── Edit Modal ──────────────────────────────────────────────────────────────

export const EditFormOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(5, 0, 0, 0.4);
  z-index: 44444447;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EditFormCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2.8rem;
  width: 440px;
  max-width: 90%;
`;

export const EditFormTitle = styled.h4`
  font-family: Roboto-m;
  font-size: 1.8rem;
  color: #373333;
  margin: 0 0 2.4rem;
`;

export const FormField = styled.div`
  margin-bottom: 1.6rem;
`;

export const FormLabel = styled.label`
  display: block;
  font-family: Roboto-m;
  font-size: 1.2rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 0.6rem;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 1rem 1.4rem;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  font-family: Roboto-r;
  font-size: 1.4rem;
  color: #373333;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
  &:focus {
    border-color: #00FF91;
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 1rem 1.4rem;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  font-family: Roboto-r;
  font-size: 1.4rem;
  color: #373333;
  outline: none;
  background: white;
  box-sizing: border-box;
  transition: border-color 0.15s;
  &:focus {
    border-color: #00FF91;
  }
`;

export const FormButtons = styled.div`
  display: flex;
  gap: 1.2rem;
  margin-top: 2.4rem;
`;

// ── Chart ───────────────────────────────────────────────────────────────────

export const ChartCard = styled.div`
  background: #fff;
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  padding: 2rem 2.4rem;
  margin-bottom: 2.4rem;
`;

export const ChartTitle = styled.div`
  font-family: Roboto-m;
  font-size: 1.4rem;
  color: #373333;
  margin-bottom: 1.6rem;
`;

export const ChartToggleRow = styled.div`
  display: inline-flex;
  background: #e8e8e8;
  border-radius: 20px;
  padding: 3px;
  margin-bottom: 1.6rem;
`;

export const ChartToggleOption = styled.button`
  padding: 0.5rem 1.6rem;
  border-radius: 18px;
  border: none;
  font-family: Roboto-m;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s;
  background: ${({ active }) => (active ? '#00FF91' : 'transparent')};
  color: ${({ active }) => (active ? '#001212' : '#6b6b6b')};
  &:hover {
    color: #001212;
  }
`;

// ── Deprecated (kept for compatibility) ─────────────────────────────────────

export const TabsRow = styled.div``;
export const TabButton = styled.button``;
export const Table = styled.table``;
export const TH = styled.th``;
export const TR = styled.tr``;
export const TD = styled.td``;
